import { zipObject } from 'es-toolkit';

import originTypeFilter from '../filters/originType';

export default class OriginType {

    static MZI = 'MZI';
    static SOIL = 'SOIL';

    static options(): Record<string, string | null> {

        const keys = Object.keys(OriginType);

        return zipObject(keys, keys.map(key => originTypeFilter(key)));
    }
}
